import React from "react";
import PropTypes from "prop-types";
import USBBPAvatarIconComponent from "./AvatarIconComponent";

/**
 * Avatar Component acts as an placeholder for image to be displayed.
 * @param {String} src - source of the image to be displayed, it can be a http uri or data-uri.
 * @param {string} id - the top level container id
 * @param {String} altText - alt text for the image source provided.
 * @param {String | number} width - dimension of the image.
 * @param {String | number} height - dimension of the image.
 * @param {boolean} compact - controls the margin / padding on the component.
 * @param {string} variant - the variant can be company, person or biller based on which default image is loaded.
 *
 * @returns {HTMLElement}
 */
const USBBPAvatarComponent = ({
  src,
  width,
  variant,
  compact,
  id,
  caption,
  additionalClasses,
}) => {
  return (
    <figure
      id={`USBBPAvatarComponent-${id}`}
      className={`${additionalClasses.join(" ")}`}
    >
      <USBBPAvatarIconComponent
        id={`${id}-span`}
        compact={compact}
        variant={variant}
        src={src}
        width={width}
      />
      {caption && (
        <figcaption id={`USBBPAvatarComponent-${id}-caption`}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

USBBPAvatarComponent.propTypes = {
  /** source of the image to be displayed, it can be a http uri or data-uri */
  src: PropTypes.string.isRequired,
  /** The top level container id */
  id: PropTypes.string.isRequired,
  /** alt text for the image source provided */
  altText: PropTypes.string,
  /** controls the margin / padding on the component */
  compact: PropTypes.bool,
  /** dimension of the image */
  width: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  /** dimension of the image */
  height: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  /** the variant can be company, person or biller based on which default image is loaded */
  variant: PropTypes.string,
  /** Caption text for image */
  caption: PropTypes.string,
  /** To add addional classes */
  additionalClasses: PropTypes.arrayOf(PropTypes.any),
};

USBBPAvatarComponent.defaultProps = {
  compact: false,
  variant: "",
  src: "",
  width: "2rem",
  id: "",
  caption: "",
  additionalClasses: [],
};

export default USBBPAvatarComponent;
